import { postAlert } from "./quartixApi";

// O `token` do envelope é gerado aqui no front, com o `randomId()`: os três
// alertas de uma mesma tentativa de login saem em requisições separadas, e ele
// é a única coisa que diz do outro lado que são a mesma pessoa na mesma tela.
// Não existe backend de autenticação para consultar depois.
export { randomId as newLoginToken } from "./randomId";

// Um caminho por passo, e não um `/login` só com o passo no corpo.
//
// O rate limit dos alertas mora no nginx e monta a chave do balde a partir do
// `$request_uri` — ele não lê corpo de requisição. Enquanto os três passos
// dividiam o mesmo caminho, dividiam o mesmo balde: uma entrada (que dispara os
// três) esvaziava a rajada e a tentativa seguinte tomava 429. Em silêncio, já
// que quem chama engole o erro. Com um caminho por passo cada um tem o seu
// balde, e a regra segue a mesma (6r/m, burst=3) em vez de afrouxada.
//
// A lista é uma allowlist explícita, não um `\`login/${action}\``: interpolar
// o `action` cru no caminho faria um valor novo virar URL nova em silêncio — e
// URL que o `map` do nginx não conhece cai no `~^/api/quartix/login`, o balde
// residual, junto com todo mundo. Passo novo aqui é uma linha aqui, uma no
// `auth_api.py` e uma no `map` do nginx.conf; as três andam juntas.
const LOGIN_PATHS = {
  press_hold: "login/press_hold",
  email_continue: "login/email_continue",
  keycode_continue: "login/keycode_continue",
};

// O caminho antigo é o fallback: um `action` fora da lista ainda avisa, só que
// pelo balde residual. Perder o alerta seria pior que dividir balde.
const LOGIN_PATH_FALLBACK = "login";

// Aviso de entrada: dispara uma vez em cada um dos tres botoes da tela de login
// (press & hold, e-mail/continue, keycode/continue) e manda para o Telegram,
// pelo mesmo prefixo do "request a demo". Qual dos tres foi continua indo no
// campo `action` do `fields` — o caminho passou a distinguir tambem, mas quem
// le a mensagem no Telegram le o `action`, nao a URL. O `token` agrupa os tres.
// Quem chama manda em cada um tudo o que a tentativa ja revelou (o
// `notifyLogin` do componente acumula), entao a ultima mensagem se basta
// sozinha.
//
// Quem chama NÃO deve esperar por isto nem deixar a falha subir: a sessão é uma
// flag no localStorage, o login não depende de rede, e uma API de e-mail fora
// do ar (ou um 429 do nginx) não pode impedir alguém de entrar. Por isso o
// `.catch()` fica no lugar da chamada, e não aqui — daqui o erro ainda serve
// para quem quiser registrar.
export async function sendLoginAlert(fields, token = null) {
  const path = LOGIN_PATHS[fields && fields.action] || LOGIN_PATH_FALLBACK;
  return postAlert(path, fields, token);
}

export default sendLoginAlert;
